// Pages
import RouterView from '@/components/pages/RouterView/Router'

import Hospitals from '@/components/pages/Hospitals/Hospitals.vue'
import Hospital from '@/components/pages/Hospitals/Hospital.vue'
import AddHospital from '@/components/pages/Hospitals/AddHospital.vue'
import HospitalOnboarding from '@/components/pages/Hospitals/HospitalOnboarding.vue'
import EditHospital from '@/components/pages/Hospitals/EditHospital.vue'

export default {
  path: '/hospitals',
  component: RouterView,
  meta: {requiresAuth: true},
  children: [
    {
      path: '',
      component: Hospitals,
      name: 'hospitals',
      meta: {breadcrumb: 'All Hospitals'},
    },
    {
      path: 'add-hospital',
      component: AddHospital,
      name: 'add-hospital',
      meta: {breadcrumb: 'Add New Hospital'}
    },
    {
      path: 'hospital-onboarding',
      component: HospitalOnboarding,
      name: 'hospital-onboarding',
      meta: {breadcrumb: 'Hospital Onboarding'}
    },
    {
      path: ':id',
      component: RouterView,
      children: [
        {
          path: '',
          component: Hospital,
          props: true,
          name: 'view-hospital'
        },
        {
          path: 'edit',
          component: EditHospital,
          props: true,
          name: 'edit-hospital'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/hospitals.js